<!-- Fiók-háttér mobilon -->
<div class="sz-sidebar-backdrop" *ngIf="narrow && drawerOpen" (click)="shell.closeDrawer()"></div>

<aside
  class="sz-sidebar"
  [class.sz-sidebar-collapsed]="collapsed && !narrow"
  [class.sz-sidebar-drawer]="narrow"
  [class.sz-sidebar-drawer-open]="narrow && drawerOpen"
>
  <!-- Kinyitott menü -->
  <ng-container *ngIf="!(collapsed && !narrow); else rail">
    <div class="sz-sidebar-head">
      <a [routerLink]="['/']" class="sz-sidebar-logo">
        <img src="assets/images/szirom/logo-full-dark.png" alt="Pharmaroad" />
      </a>
      <button type="button" class="sz-sidebar-iconbtn" (click)="narrow ? shell.closeDrawer() : toggleCollapse()" [title]="narrow ? 'Bezárás' : 'Menü összecsukása'">
        <span class="sz-icon">{{ narrow ? 'close' : 'left_panel_close' }}</span>
      </button>
    </div>

    <nav class="sz-sidebar-nav">
      <ng-container *ngFor="let it of entries">
        <!-- levél -->
        <a
          *ngIf="!it.children"
          class="sz-nav-item"
          [class.sz-nav-item-active]="isActive(it)"
          [routerLink]="it.routerLink"
          (click)="shell.closeDrawer()"
        >
          <span class="sz-icon" [class.sz-icon-fill]="isActive(it)">{{ it.icon }}</span>
          <span class="sz-nav-label">{{ 'page:' + it.label | i18next }}</span>
        </a>

        <!-- csoport -->
        <div *ngIf="it.children" class="sz-nav-group">
          <button type="button" class="sz-nav-item sz-nav-group-head" (click)="toggleGroup(it)">
            <span class="sz-icon">{{ it.icon }}</span>
            <span class="sz-nav-label sz-nav-label-grow">{{ 'page:' + it.label | i18next }}</span>
            <span class="sz-icon sz-nav-caret">{{ it.open ? 'expand_less' : 'expand_more' }}</span>
          </button>
          <div class="sz-nav-children" *ngIf="it.open">
            <a
              *ngFor="let c of it.children"
              class="sz-nav-child"
              [class.sz-nav-child-active]="isActive(c)"
              [routerLink]="c.routerLink"
              (click)="shell.closeDrawer()"
            >
              {{ 'page:' + c.label | i18next }}
            </a>
          </div>
        </div>
      </ng-container>
    </nav>

    <div class="sz-sidebar-user">
      <a class="sz-sidebar-avatar sz-sidebar-profile" [routerLink]="['/settings']" title="Profil és beállítások" (click)="shell.closeDrawer()">{{ initials }}</a>
      <a class="sz-sidebar-usertext sz-sidebar-profile" [routerLink]="['/settings']" title="Profil és beállítások" (click)="shell.closeDrawer()">
        <div class="sz-sidebar-username" [title]="userName">{{ userName }}</div>
        <div class="sz-sidebar-usersub" [title]="userSub">{{ userSub }}</div>
      </a>
      <button type="button" class="sz-sidebar-iconbtn sz-sidebar-logout" title="Kilépés" (click)="logout()">
        <span class="sz-icon">logout</span>
      </button>
    </div>
  </ng-container>

  <!-- Ikonsáv (összecsukva) -->
  <ng-template #rail>
    <div class="sz-sidebar-head sz-sidebar-head-rail">
      <img src="assets/images/szirom/logo-dark.png" alt="Pharmaroad" class="sz-sidebar-mark" (click)="toggleCollapse()" title="Menü kinyitása" />
    </div>
    <nav class="sz-sidebar-nav sz-sidebar-nav-rail">
      <button
        *ngFor="let it of entries"
        type="button"
        class="sz-rail-item"
        [class.sz-rail-item-active]="isActive(it)"
        [title]="'page:' + it.label | i18next"
        (click)="go(it)"
      >
        <span class="sz-icon sz-icon-24" [class.sz-icon-fill]="isActive(it)">{{ it.icon }}</span>
      </button>
    </nav>
    <div class="sz-sidebar-user sz-sidebar-user-rail">
      <a class="sz-sidebar-avatar sz-sidebar-profile" [routerLink]="['/settings']" [title]="userName + ' · profil'">{{ initials }}</a>
      <button type="button" class="sz-sidebar-iconbtn sz-sidebar-logout" title="Kilépés" (click)="logout()">
        <span class="sz-icon">logout</span>
      </button>
    </div>
  </ng-template>
</aside>
